export default {
  myClients: {
    items: [],
    documents: 0,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/clients/initialState.js